(function() {
    $(document).ready(function() {
        const oIpss = $.extend(true, {}, window.c24.lp.ipssReforged);
        oIpss.isWidgetPrefilledWithLastSearchData = true;
        oIpss.prefilledLabelsKeys = {
            'deviceAge': 'deviceAge',
            'producer': 'manufacturer',
            'device': 'model',
        };

        oIpss.filterChipLabelMap.offer = {
            'singular': 'Antrag',
            'plural': 'Anträge',
        };

        oIpss.bPriceInCents = true;

        oIpss.tileHeadlineMap.offer = 'Ihr letzter Antrag';
        oIpss.tileHeadlineMap.contract = 'Ihr letzter Vertrag';

        oIpss.bWholeTileClickable = false;

        oIpss.showTeaserLabelInIpss = true;

        oIpss.renderHeadline = function(data) {
            if (!oIpss.bUseTilesLayout) { // remove when all ipss are tiles layout
                const self = this;
                let amountHeadline;
                let typeHeadline;
                let amountHeadlineExtend = '';
                let newHeadline;
                const $headlineShowEverything = $('[id^="lastSearches"] .ipssHeadline.lastSearches', self.domContext);
                const $tabHeadlineLastSearches = $('.cssTabHeaderItem[data-contentbox^="lastSearches"]', self.domContext);
                const iAmountNonContracts = data.contracts ? data.contracts.length : 0;
                const iAmountLastSearches = data.lastSearches ? data.lastSearches.length : 0;
                const iAmountTotal = iAmountNonContracts + iAmountLastSearches;
                let bContractsOnly = false;

                if (!self.isValidApiResponse(data)) {
                    newHeadline = {};

                    newHeadline.general = 'Meine letzte Aktivität';
                    newHeadline.lastSearches = 'Meine letzten Vergleiche';
                } else {

                    newHeadline = {};

                    if (data.contracts && iAmountNonContracts > 0) {

                        if (iAmountLastSearches > 0) {
                            typeHeadline = 'Aktivität';
                        } else {
                            bContractsOnly = true;

                            if (iAmountNonContracts > 1) {
                                typeHeadline = 'Anträge';
                            } else {
                                typeHeadline = 'Antrag';
                            }
                        }

                        if (iAmountTotal < 2) {
                            if (bContractsOnly) {
                                amountHeadline = 'Mein letzter ';
                            } else {
                                amountHeadline = 'Meine letzte ';
                                amountHeadlineExtend = '';
                            }
                        } else {
                            if (bContractsOnly) {
                                amountHeadline = 'Meine letzten ';
                                amountHeadlineExtend = '';
                            } else {
                                amountHeadline = 'Meine letzten ';
                                amountHeadlineExtend = 'en';
                            }
                        }

                        newHeadline.general = amountHeadline + typeHeadline + amountHeadlineExtend;
                    }

                    if (data.lastSearches) {

                        typeHeadline = 'Vergleich';

                        if (data.lastSearches.length < 2) {
                            amountHeadline = 'Mein letzter ';
                            amountHeadlineExtend = '';
                        } else {
                            amountHeadline = 'Meine letzten ';
                            amountHeadlineExtend = 'e';
                        }

                        newHeadline.lastSearches = amountHeadline + typeHeadline + amountHeadlineExtend;
                    }
                }

                if (self.bShowContracts) {
                    if (iAmountNonContracts < 1 && data.lastSearches) {
                        newHeadline.general = newHeadline.lastSearches;
                        newHeadline.lastSearches = null;
                    }

                    $tabHeadlineLastSearches.text(newHeadline.general);

                    if (newHeadline.lastSearches === null) {
                        $headlineShowEverything.remove();
                    } else {
                        $headlineShowEverything.text(newHeadline.lastSearches);
                    }

                } else {
                    $('[id^="lastSearches"] .ipssHeadline:not(.showEverything)', self.domContext).text(newHeadline.general);
                    $headlineShowEverything.text(newHeadline.lastSearches);
                }
            } else {
                const self = this;
                let amountHeadline;
                let typeHeadline;
                let amountHeadlineExtend = '';
                const newHeadline = {};
                const $headlineShowEverything = $('[id^="lastSearches"] .ipssHeadline.lastSearches', self.domContext);
                const $tabHeadlineLastSearches = $('.cssTabHeaderItem[data-contentbox^="lastSearches"]', self.domContext);

                self.iAmountNonContracts = data.contracts ? data.contracts.length : 0;
                self.iAmountLastSearches = data.lastSearches ? data.lastSearches.length : 0;
                self.iAmountTotal = self.iAmountNonContracts + self.iAmountLastSearches;

                if (!self.isValidApiResponse(data)) {

                    newHeadline.general = 'Meine letzte Aktivität';
                    newHeadline.lastSearches = 'Meine letzten Vergleiche';
                } else {
                    if (data.contracts && self.iAmountNonContracts > 0) {

                        typeHeadline = 'Aktivität';

                        if (self.iAmountTotal < 2) {
                            amountHeadline = 'Meine letzte ';
                            amountHeadlineExtend = '';
                        } else {
                            amountHeadline = 'Meine letzten ';
                            amountHeadlineExtend = 'en';
                        }

                        newHeadline.general = amountHeadline + typeHeadline + amountHeadlineExtend;
                    }

                    if (data.lastSearches) {

                        typeHeadline = 'Vergleich';

                        if (data.lastSearches.length < 2) {
                            amountHeadline = 'Mein letzter ';
                            amountHeadlineExtend = '';
                        } else {
                            amountHeadline = 'Meine letzten ';
                            amountHeadlineExtend = 'e';
                        }

                        newHeadline.lastSearches = amountHeadline + typeHeadline + amountHeadlineExtend;
                    }
                }

                if (self.bShowContracts) {

                    if (self.iAmountNonContracts < 1 && data.lastSearches) {
                        newHeadline.general = newHeadline.lastSearches;
                        newHeadline.lastSearches = null;
                    }

                    $tabHeadlineLastSearches.text(newHeadline.general);

                    if (newHeadline.lastSearches === null && self.aAppointmentsGrouped?.length < 0) {
                        $headlineShowEverything.remove();
                    } else {
                        $headlineShowEverything.text(newHeadline.lastSearches);
                    }

                } else {
                    $('[id^="lastSearches"] .ipssHeadline.nonContracts', self.domContext).text(newHeadline.general);
                    $headlineShowEverything.text(newHeadline.lastSearches);
                }

                if (self.bUseTilesLayout && self.bIsMobile) {
                    $('.ipssHeadline.activities', self.domContext).text(`Meine Aktivitäten (${self.iAmountTotal})`);
                }
            }
        };


        oIpss.renderDataArrayProductSpecificTileHeadline = function(sRenderType, data) {
            if (sRenderType === 'offer' && data?.completed === false) {
                return 'Antrag vervollständigen';
            }

            return false;
        };

        oIpss.renderProductSpecificLabels = function (data) {
            const labels = { };
            const dataInputs = data.inputs;
            const ageMap = {
                'UNDER_TWO_WEEKS': 'bis 2 Wochen',
                'UNDER_SIX_WEEKS': '2 Wochen bis 6 Wochen',
                'UNDER_SIX_MONTHS': '6 Wochen bis halbes Jahr',
                'UNDER_TWELVE_MONTHS': 'halbes Jahr bis 1 Jahr',
                'UNDER_TWO_YEARS': '1 Jahr bis 2 Jahre',
                'OVER_TWO_YEARS': 'älter als 2 Jahre',
            };
            const priceRangeMap = {
                'UPTO_250': '0 - 250€',
                'UPTO_500': '251 - 500 €',
                'UPTO_750': '501 - 750 €',
                'UPTO_1000': '751 - 1.000 €',
                'UPTO_1250': '1.001 - 1.250 €',
                'UPTO_1500': '1.251 - 1.500 €',
                'UPTO_1750': '1.501 - 1.750€',
                'UPTO_2000': '1.751 - 2.000 €',
                'UPTO_2500': '2.001 - 2.500 €',
            };

            if (!data.inputs) {
                return labels;
            }

            if (dataInputs.model) {
                labels.model = dataInputs.model;

                if (oIpss.bUseTilesLayout) {
                    labels.model = ' | ' + labels.model;
                }
            } else {
                labels.model = null;
            }

            if (dataInputs.manufacturer) {
                labels.manufacturer = dataInputs.manufacturer;
            } else {
                labels.manufacturer = null;
            }

            if (dataInputs.priceRange) {
                labels.priceRange = priceRangeMap[dataInputs.priceRange] || null;
            } else {
                labels.priceRange = null;
            }

            if (dataInputs.isPremium === true || dataInputs.isPremium === false) {
                labels.isPremium = dataInputs.isPremium ? 'ja' : 'nein';
            } else {
                labels.isPremium = null;
            }

            if (dataInputs.deviceAge) {
                labels.deviceAge = ageMap[dataInputs.deviceAge] || null;
            } else {
                labels.deviceAge = null;
            }

            return labels;
        };

        oIpss.renderLabels = function(element, data) {
            if (data.labels.priceMin == null && data.labels.priceMax == null) {
                $('.priceContainer', element).remove();
            }

            $.each(data.labels, function(key, value) {
                if (value != null) {
                    $('.' + key, element).html($.parseHTML(value));
                } else {
                    if (key === 'tariffName') {
                        $('.tariffSeparator', element).remove();
                    }
                    $('.' + key, element).remove();
                    $('.' + key + 'Container', element).remove();
                }
            });
        };

        // oIpss.overrideData = { 'version': 1, 'lastUpdate': 1647377034710, 'lastSearches': [ { 'deviceOutput': 'desktop', 'time': 1647376836973, 'result': { 'cta': { 'text': 'Ergebnis anzeigen', 'urlDesktop': 'https://f12.handyversicherung.check24-test.de/c24-odi-checkin/desktop/results?wpset=hanv_filter&product=HANV&deviceAge=UNDER_TWO_WEEKS&isPremium=false&paidPrice=UPTO_1250&selectedManufacturer=Apple&paymentPeriod=YEARLY&selectedPhoneModel=2582838&withDeductible=true', 'urlMobile': 'https://f12.handyversicherung.check24-test.de/c24-odi-checkin/mobile/results?wpset=hanv_filter&product=HANV&deviceAge=UNDER_TWO_WEEKS&isPremium=false&paidPrice=UPTO_1250&selectedManufacturer=Apple&paymentPeriod=YEARLY&selectedPhoneModel=2582838&withDeductible=true', }, 'tariff': { 'best': { 'period': 'YEARLY', 'price': 8490, }, }, 'inputs': { 'deviceAge': 'UNDER_TWO_WEEKS', 'model': 'iPhone 13 Pro 128GB', 'priceRange': 'UPTO_1250', 'isPremium': false, }, 'urlDelete': 'https://f12.handyversicherung.check24-test.de/ap-ipss-api/HANV/6230f9c584b68e3a0bd49a1d', }, }, ], 'contracts': [ { 'status': { 'color': 'yellow', 'text': 'Antrag übermittelt', }, 'time': 1647376864843, 'type': 'offer', 'deviceOutput': 'desktop', 'origin': 'external', 'publicId': 'HANV-626800211', 'cta': [ { 'type': 'secondary', 'text': 'Details anzeigen', 'urlDesktop': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-626800211', 'urlMobile': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-626800211', 'urlApp': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-626800211', }, ], 'tariff': { 'name': 'Elektronik-Versicherung Basis', 'period': 'YEARLY', 'price': 8490, }, 'insuranceKey': 'inzmo', 'inputs': { 'isPremium': false, 'model': 'iPhone 13 Pro 128GB', }, }, { 'status': { 'text': 'aktiv: seit 15.06.2018', 'color': 'green', }, 'time': 1627124788584, 'type': 'contract', 'origin': 'external', 'publicId': 'AP-HANV-533060311', 'cta': [ { 'type': 'secondary', 'text': 'Details anzeigen', 'urlDesktop': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/AP-HANV-533060311', 'urlMobile': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/AP-HANV-533060311', 'urlApp': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/AP-HANV-533060311', }, ], 'tariff': { 'name': 'Premium', 'period': 'YEARLY', 'price': 4905, }, 'insuranceKey': 'allianz_global', 'inputs': { 'isPremium': true, 'model': 'iPhone 8 64GB', }, }, { 'status': { 'color': 'yellow', 'text': 'Antrag übermittelt', }, 'time': 1622806114479, 'type': 'offer', 'deviceOutput': 'desktop', 'origin': 'external', 'publicId': 'HANV-7812995', 'cta': [ { 'type': 'secondary', 'text': 'Details anzeigen', 'urlDesktop': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-7812995', 'urlMobile': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-7812995', 'urlApp': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-7812995', }, ], 'tariff': { 'name': 'Elektronik-Versicherung Basis', 'period': 'YEARLY', 'price': 5990, }, 'insuranceKey': 'inzmo', 'inputs': { 'isPremium': false, 'model': 'iPhone 12 Pro 128GB', }, }, { 'status': { 'color': 'yellow', 'text': 'Antrag übermittelt', }, 'time': 1613980571182, 'type': 'offer', 'deviceOutput': 'desktop', 'origin': 'external', 'publicId': 'HANV-626800084', 'cta': [ { 'type': 'secondary', 'text': 'Details anzeigen', 'urlDesktop': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-626800084', 'urlMobile': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-626800084', 'urlApp': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-626800084', }, ], 'tariff': { 'name': 'Elektronik-Versicherung Basis', 'period': 'YEARLY', 'price': 8490, }, 'insuranceKey': 'inzmo', 'inputs': { 'isPremium': false, 'model': 'iPhone 13 Pro 128GB', }, }, { 'status': { 'text': 'aktiv: seit 15.06.2018', 'color': 'green', }, 'time': 1595588788584, 'type': 'contract', 'origin': 'external', 'publicId': 'AP-HANV-53306031', 'cta': [ { 'type': 'secondary', 'text': 'Details anzeigen', 'urlDesktop': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/AP-HANV-53306031', 'urlMobile': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/AP-HANV-53306031', 'urlApp': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/AP-HANV-53306031', }, ], 'tariff': { 'name': 'Premium', 'period': 'YEARLY', 'price': 4905, }, 'insuranceKey': 'allianz_global', 'inputs': { 'isPremium': true, 'model': 'iPhone 8 64GB', }, }, ], }; oIpss.overrideData = { 'version': 1, 'lastUpdate': 1647377034710, 'lastSearches': [ { 'deviceOutput': 'mobile', 'time': 1647376836973, 'result': { 'cta': { 'text': 'Ergebnis anzeigen', 'urlDesktop': 'https://f12.handyversicherung.check24-test.de/c24-odi-checkin/desktop/results?wpset=hanv_filter&product=HANV&deviceAge=UNDER_TWO_WEEKS&isPremium=false&paidPrice=UPTO_1250&selectedManufacturer=Apple&paymentPeriod=YEARLY&selectedPhoneModel=2582838&withDeductible=true', 'urlMobile': 'https://f12.handyversicherung.check24-test.de/c24-odi-checkin/mobile/results?wpset=hanv_filter&product=HANV&deviceAge=UNDER_TWO_WEEKS&isPremium=false&paidPrice=UPTO_1250&selectedManufacturer=Apple&paymentPeriod=YEARLY&selectedPhoneModel=2582838&withDeductible=true', }, 'tariff': { 'best': { 'period': 'YEARLY', 'price': 8490, }, }, 'inputs': { 'deviceAge': 'UNDER_TWO_WEEKS', 'model': 'iPhone 13 Pro 128GB', 'priceRange': 'UPTO_1250', 'isPremium': false, }, 'urlDelete': 'https://f12.handyversicherung.check24-test.de/ap-ipss-api/HANV/6230f9c584b68e3a0bd49a1d', }, }, ], 'contracts': [ { 'status': { 'color': 'yellow', 'text': 'Antrag übermittelt', }, 'time': 1647376864843, 'type': 'offer', 'deviceOutput': 'mobile', 'origin': 'external', 'publicId': 'HANV-626800211', 'cta': [ { 'type': 'secondary', 'text': 'Details anzeigen', 'urlDesktop': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-626800211', 'urlMobile': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-626800211', 'urlApp': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-626800211', }, ], 'tariff': { 'name': 'Elektronik-Versicherung Basis', 'period': 'YEARLY', 'price': 8490, }, 'insuranceKey': 'inzmo', 'inputs': { 'isPremium': false, 'model': 'iPhone 13 Pro 128GB', }, }, { 'status': { 'text': 'aktiv: seit 15.06.2018', 'color': 'green', }, 'time': 1627124788584, 'type': 'contract', 'origin': 'external', 'publicId': 'AP-HANV-533060311', 'cta': [ { 'type': 'secondary', 'text': 'Details anzeigen', 'urlDesktop': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/AP-HANV-533060311', 'urlMobile': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/AP-HANV-533060311', 'urlApp': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/AP-HANV-533060311', }, ], 'tariff': { 'name': 'Premium', 'period': 'YEARLY', 'price': 4905, }, 'insuranceKey': 'allianz_global', 'inputs': { 'isPremium': true, 'model': 'iPhone 8 64GB', }, }, { 'status': { 'color': 'yellow', 'text': 'Antrag übermittelt', }, 'time': 1622806114479, 'type': 'offer', 'deviceOutput': 'desktop', 'origin': 'external', 'publicId': 'HANV-7812995', 'cta': [ { 'type': 'secondary', 'text': 'Details anzeigen', 'urlDesktop': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-7812995', 'urlMobile': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-7812995', 'urlApp': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-7812995', }, ], 'tariff': { 'name': 'Elektronik-Versicherung Basis', 'period': 'YEARLY', 'price': 5990, }, 'insuranceKey': 'inzmo', 'inputs': { 'isPremium': false, 'model': 'iPhone 12 Pro 128GB', }, }, { 'status': { 'color': 'yellow', 'text': 'Antrag übermittelt', }, 'time': 1613980571182, 'type': 'offer', 'deviceOutput': 'desktop', 'origin': 'external', 'publicId': 'HANV-626800084', 'cta': [ { 'type': 'secondary', 'text': 'Details anzeigen', 'urlDesktop': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-626800084', 'urlMobile': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-626800084', 'urlApp': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-626800084', }, ], 'tariff': { 'name': 'Elektronik-Versicherung Basis', 'period': 'YEARLY', 'price': 8490, }, 'insuranceKey': 'inzmo', 'inputs': { 'isPremium': false, 'model': 'iPhone 13 Pro 128GB', }, }, { 'status': { 'text': 'aktiv: seit 15.06.2018', 'color': 'green', }, 'time': 1595588788584, 'type': 'contract', 'origin': 'external', 'publicId': 'AP-HANV-53306031', 'cta': [ { 'type': 'secondary', 'text': 'Details anzeigen', 'urlDesktop': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/AP-HANV-53306031', 'urlMobile': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/AP-HANV-53306031', 'urlApp': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/AP-HANV-53306031', }, ], 'tariff': { 'name': 'Premium', 'period': 'YEARLY', 'price': 4905, }, 'insuranceKey': 'allianz_global', 'inputs': { 'isPremium': true, 'model': 'iPhone 8 64GB', }, }, ], };

        // new tiles layout + static tile
        // oIpss.overrideData = { 'version': 1, 'lastUpdate': 1647377034710, 'lastSearches': [ { 'deviceOutput': 'mobile', 'time': 1647376836973, 'result': { 'cta': { 'text': 'Ergebnis anzeigen', 'urlDesktop': 'https://f12.handyversicherung.check24-test.de/c24-odi-checkin/desktop/results?wpset=hanv_filter&product=HANV&deviceAge=UNDER_TWO_WEEKS&isPremium=false&paidPrice=UPTO_1250&selectedManufacturer=Apple&paymentPeriod=YEARLY&selectedPhoneModel=2582838&withDeductible=true', 'urlMobile': 'https://f12.handyversicherung.check24-test.de/c24-odi-checkin/mobile/results?wpset=hanv_filter&product=HANV&deviceAge=UNDER_TWO_WEEKS&isPremium=false&paidPrice=UPTO_1250&selectedManufacturer=Apple&paymentPeriod=YEARLY&selectedPhoneModel=2582838&withDeductible=true', }, 'tariff': { 'best': { 'period': 'YEARLY', 'price': 8490, }, }, 'inputs': { 'deviceAge': 'UNDER_TWO_WEEKS', 'model': 'iPhone 13 Pro 128GB', 'priceRange': 'UPTO_1250', 'isPremium': false, 'manufacturer': 'Apple', 'fittingTariffs': 45, }, 'urlDelete': 'https://f12.handyversicherung.check24-test.de/ap-ipss-api/HANV/6230f9c584b68e3a0bd49a1d', }, }, ], 'contracts': [ { 'status': { 'color': 'yellow', 'text': 'Antrag übermittelt', }, 'time': 1647376864843, 'type': 'offer', 'deviceOutput': 'mobile', 'origin': 'external', 'publicId': 'HANV-626800211', 'cta': [ { 'type': 'primary', 'text': 'Details anzeigen', 'urlDesktop': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-626800211', 'urlMobile': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-626800211', 'urlApp': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-626800211', }, ], 'tariff': { 'name': 'Elektronik-Versicherung Basis', 'period': 'YEARLY', 'price': 8490, }, 'insuranceKey': 'inzmo', 'inputs': { 'isPremium': false, 'model': 'iPhone 13 Pro 128GB', 'manufacturer': 'Apple', }, 'urlDelete': 'https', }, { 'status': { 'text': 'aktiv: seit 15.06.2018', 'color': 'green', }, 'time': 1627124788584, 'type': 'contract', 'origin': 'external', 'publicId': 'AP-HANV-533060311', 'cta': [ { 'type': 'primary', 'text': 'Details anzeigen', 'urlDesktop': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/AP-HANV-533060311', 'urlMobile': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/AP-HANV-533060311', 'urlApp': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/AP-HANV-533060311', }, ], 'tariff': { 'name': 'Premium', 'period': 'YEARLY', 'price': 4905, }, 'insuranceKey': 'allianz_global', 'inputs': { 'isPremium': true, 'model': 'iPhone 8 64GB', 'manufacturer': 'Apple', }, 'urlDelete': 'https', }, { 'status': { 'color': 'yellow', 'text': 'Antrag übermittelt', }, 'time': 1622806114479, 'type': 'offer', 'deviceOutput': 'desktop', 'origin': 'external', 'publicId': 'HANV-7812995', 'cta': [ { 'type': 'primary', 'text': 'Details anzeigen', 'urlDesktop': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-7812995', 'urlMobile': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-7812995', 'urlApp': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-7812995', }, ], 'tariff': { 'name': 'Elektronik-Versicherung Basis', 'period': 'YEARLY', 'price': 5990, }, 'insuranceKey': 'inzmo', 'inputs': { 'isPremium': false, 'model': 'iPhone 12 Pro 128GB', 'manufacturer': 'Apple', }, 'urlDelete': 'https', }, { 'status': { 'color': 'yellow', 'text': 'Antrag übermittelt', }, 'time': 1613980571182, 'type': 'offer', 'deviceOutput': 'desktop', 'origin': 'external', 'publicId': 'HANV-626800084', 'cta': [ { 'type': 'primary', 'text': 'Details anzeigen', 'urlDesktop': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-626800084', 'urlMobile': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-626800084', 'urlApp': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-626800084', }, ], 'tariff': { 'name': 'Elektronik-Versicherung Basis', 'period': 'YEARLY', 'price': 8490, }, 'insuranceKey': 'inzmo', 'inputs': { 'isPremium': false, 'model': 'iPhone 13 Pro 128GB', 'manufacturer': 'Apple', }, 'urlDelete': 'https', }, { 'status': { 'color': 'gray', 'text': 'Antrag übermittelt', }, 'time': 1613980571182, 'type': 'incompleteContract', 'deviceOutput': 'desktop', 'origin': 'external', 'publicId': 'HANV-626800084', 'cta': [ { 'type': 'primary', 'text': 'Details anzeigen', 'urlDesktop': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-626800084', 'urlMobile': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-626800084', 'urlApp': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/HANV-626800084', }, ], 'tariff': { 'name': 'Elektronik-Versicherung Basis', 'period': 'YEARLY', 'price': 9999, }, 'insuranceKey': 'inzmo', 'inputs': { 'isPremium': false, 'model': 'iPhone 13 Pro 1280GB', 'manufacturer': 'Apple', }, 'urlDelete': 'https', }, { 'status': { 'text': 'aktiv: seit 15.06.2018', 'color': 'green', }, 'time': 1595588788584, 'type': 'contract', 'origin': 'external', 'publicId': 'AP-HANV-53306031', 'cta': [ { 'type': 'primary', 'text': 'Details anzeigen', 'urlDesktop': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/AP-HANV-53306031', 'urlMobile': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/AP-HANV-53306031', 'urlApp': 'https://www.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/AP-HANV-53306031', }, ], 'tariff': { 'name': 'HandySchutzbreif basis ohne Diebstahl', 'period': 'YEARLY', 'price': 4905, }, 'insuranceKey': 'allianz_global', 'inputs': { 'isPremium': true, 'model': 'iPhone 8 64GB', 'manufacturer': 'Apple', }, }, ], 'staticTiles': [ { 'cta': [ { 'type': 'primary', // blue button 'text': 'Vertrag hinzufügen', 'urlDesktop': 'primary staticTile URL urlDesktop', 'urlMobile': 'primary staticTile URL urlMobile', 'urlApp': 'URL', // optional; fallback urlMobile 'urlTabletApp': 'URL', // optional; fallback urlDesktop }, ], 'urlDelete': 'https://delete static tile URL', }, ], crossSelling: [ { 'tariff': { 'best': { 'period': 'YEARLY', 'price': 4567, }, }, 'produktKey': 'kfzsb', 'image': { 'urlDesktop': 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/1.png', 'urlMobile': { 'default': 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/2.png', 'highRes': 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/3.png', }, 'urlApp': 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/679.png', 'urlTabletApp': 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/680.png', }, 'cta': [ { 'type': 'primary', // blue button 'text': 'Vertrag hinzufügen', 'urlDesktop': 'primary crossSelling URL urlDesktop', 'urlMobile': 'primary crossSelling URL urlMobile', 'urlApp': 'URL', // optional; fallback urlMobile 'urlTabletApp': 'URL', // optional; fallback urlDesktop }, ], 'urlDelete': 'https://delete crossSelling tile URL', }, { 'tariff': { 'best': { 'period': 'monthly', 'price': 1234, }, }, 'produktKey': 'mop', 'image': { 'urlDesktop': 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/4.png', 'urlMobile': { 'default': 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/5.png', 'highRes': 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/6.png', }, 'urlApp': 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/680.png', 'urlTabletApp': 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/681.png', }, 'cta': [ { 'type': 'primary', // blue button 'text': 'Vertrag hinzufügen', 'urlDesktop': 'primary crossSelling URL urlDesktop', 'urlMobile': 'primary crossSelling URL urlMobile', 'urlApp': 'URL', // optional; fallback urlMobile 'urlTabletApp': 'URL', // optional; fallback urlDesktop }, ], }, ], };

        oIpss.overrideData = {
            'version': 2,
            'lastUpdate': 1728569228144,
            'lastSearches': [
                {
                    'deviceOutput': 'app',
                    'time': 1728464211903,
                    'result': {
                        'cta': {
                            'text': 'Vergleich anzeigen',
                            'type': 'primary',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                        },
                        'tariff': {
                            'best': {
                                'period': 'monthly',
                                'price': 669,
                            },
                        },
                        'inputs': {
                            'deviceAge': 'UNDER_TWO_WEEKS',
                            'model': 'Pixel 9 Pro Fold 512GB',
                            'manufacturer': 'Google',
                            'fittingTariffs': 8,
                        },
                        'urlDelete': 'https://urlDelete',
                    },
                },
            ],
            'contracts': [
                {
                    'status': {
                        'text': 'IMEI nachreichen',
                        'color': 'yellow',
                    },
                    'time': 1728569228173,
                    'type': 'offer',
                    'origin': 'external',
                    'publicId': 'HANV-9345118',
                    'info': 'IMEI nachreichen',
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'jetzt vervollständigen',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                            'urlApp': 'https://urlApp',
                        },
                    ],
                    'tariff': {
                        'period': 'MONTHLY',
                        'name': 'Basis Elektronik-Versicherung',
                        'price': 509,
                    },
                    'insuranceKey': 'astradirect',
                    'inputs': {
                        'deviceAge': 'UNDER_TWO_WEEKS',
                        'fittingTariffs': 1,
                        'manufacturer': 'Apple',
                        'model': 'iPhone 14 128GB',
                    },
                    'completed': false,
                },
                {
                    'status': {
                        'text': 'Antrag übermittelt',
                        'color': 'yellow',
                    },
                    'time': 1723558017206,
                    'type': 'offer',
                    'deviceOutput': 'desktop',
                    'origin': 'external',
                    'publicId': 'HANV-10152049',
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'Details anzeigen',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                            'urlApp': 'https://urlApp',
                        },
                    ],
                    'tariff': {
                        'period': 'MONTHLY',
                        'name': 'Device Premium Protect online',
                        'price': 779,
                    },
                    'insuranceKey': 'mobilegarantie',
                    'inputs': {
                        'deviceAge': 'UNDER_TWO_WEEKS',
                        'fittingTariffs': 1,
                        'manufacturer': 'Apple',
                        'model': 'iPhone 15 128GB',
                    },
                },
                {
                    'status': {
                        'text': 'Antrag übermittelt',
                        'color': 'yellow',
                    },
                    'time': 1719584581925,
                    'type': 'offer',
                    'origin': 'external',
                    'publicId': 'HANV-10043785',
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'Details anzeigen',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                            'urlApp': 'https://urlApp',
                        },
                    ],
                    'tariff': {
                        'period': 'MONTHLY',
                        'name': 'Basis Elektronik-Versicherung',
                        'price': 469.00000000000006,
                    },
                    'insuranceKey': 'astradirect',
                    'inputs': {
                        'deviceAge': 'UNDER_TWO_WEEKS',
                        'fittingTariffs': 1,
                        'manufacturer': 'Apple',
                        'model': 'iPhone 15 128GB',
                    },
                },
                {
                    'status': {
                        'text': 'Antrag in Bearbeitung',
                        'color': 'yellow',
                    },
                    'time': 1718272740428,
                    'type': 'offer',
                    'origin': 'external',
                    'publicId': 'HANV-22303729',
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'Details anzeigen',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                            'urlApp': 'https://urlApp',
                        },
                    ],
                    'tariff': {
                        'period': 'MONTHLY',
                        'name': 'Premium Elektronik-Versicherung',
                        'price': 669,
                    },
                    'insuranceKey': 'astradirect',
                    'inputs': {
                        'deviceAge': 'UNDER_TWO_WEEKS',
                        'fittingTariffs': 1,
                        'manufacturer': 'Apple',
                        'model': 'iPhone 15 128GB',
                    },
                },
                {
                    'status': {
                        'text': 'Antrag übermittelt',
                        'color': 'yellow',
                    },
                    'time': 1711621405098,
                    'type': 'offer',
                    'deviceOutput': 'desktop',
                    'origin': 'external',
                    'publicId': 'HANV-9853955',
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'Details anzeigen',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                            'urlApp': 'https://urlApp',
                        },
                    ],
                    'tariff': {
                        'period': 'MONTHLY',
                        'name': 'Komplettschutz Basis',
                        'price': 850,
                    },
                    'insuranceKey': 'wertgarantie',
                    'inputs': {
                        'deviceAge': 'UNDER_TWO_WEEKS',
                        'fittingTariffs': 1,
                        'manufacturer': 'Samsung',
                        'model': 'Galaxy S24 128GB',
                    },
                },
                {
                    'status': {
                        'text': 'Antrag übermittelt',
                        'color': 'yellow',
                    },
                    'time': 1711468705473,
                    'type': 'offer',
                    'deviceOutput': 'desktop',
                    'origin': 'external',
                    'publicId': 'HANV-9849550',
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'Details anzeigen',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                            'urlApp': 'https://urlApp',
                        },
                    ],
                    'tariff': {
                        'period': 'MONTHLY',
                        'name': 'Komplettschutz Basis',
                        'price': 1100,
                    },
                    'insuranceKey': 'wertgarantie',
                    'inputs': {
                        'deviceAge': 'UNDER_TWO_WEEKS',
                        'fittingTariffs': 1,
                        'manufacturer': 'Apple',
                        'model': 'iPhone 15 128GB',
                    },
                },
                {
                    'status': {
                        'text': 'aktiv: seit 09.09.2024',
                        'color': 'green',
                    },
                    'time': 1725875650660,
                    'type': 'contract',
                    'deviceOutput': 'desktop',
                    'origin': 'external',
                    'publicId': 'MG000064844',
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'zur Vertragsübersicht',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                            'urlApp': 'https://urlApp',
                        },
                    ],
                    'tariff': {
                        'period': 'MONTHLY',
                        'name': 'Device Premium Protect online',
                        'price': 779,
                    },
                    'insuranceKey': 'mobilegarantie',
                    'inputs': {
                        'deviceAge': 'UNDER_TWO_WEEKS',
                        'manufacturer': 'Apple',
                        'model': 'iPhone 15 128GB',
                        'fittingTariffs': 1,
                    },
                },
            ],
            'staticTiles': [
                {
                    'cta': [
                        {
                            'text': 'jetzt Vertrag hinzufügen',
                            'type': 'primary',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                        },
                    ],
                    'time': 1728569228173,
                    'deviceOutput': 'desktop',
                    'subHeadline': 'Nicht bei uns abgeschlossen?',
                    'logo': 'https://handyversicherung.check24-test.de/content/foreign_contract_icon.svg',
                    'textLine1': 'Vertrag digitalisieren',
                    'textLine2': 'Keine Frist verpassen',
                    'textLine3': 'Günstigeres Angebot finden',
                },
            ],
        };

        oIpss.bind('hav', 'https://handyversicherung' + window.c24LpDomain + '/ap-ipss-api/hanv/v2', $('.mod24ac.hav'));
    });
})();
